module.exports = __webpack_public_path__ + "static/media/search-icon.1bdba02f.svg";